"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[940,1416],{

/***/ 20940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ topicPageV2; }
});

// EXTERNAL MODULE: ./src/components/articles-v2/EmailInput.tsx
var EmailInput = __webpack_require__(41583);
// EXTERNAL MODULE: ./src/components/articles-v2/ImageAsset.tsx
var ImageAsset = __webpack_require__(54645);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./src/components/shared/EmailInput.tsx
var shared_EmailInput = __webpack_require__(51416);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Heading/Heading.mjs
var Heading = __webpack_require__(37982);
;// CONCATENATED MODULE: ./src/components/shared/Heading.tsx



var H3 = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, (0,_object_spread/* default */.Z)({
        fontSize: [
            "s2",
            null,
            "s3"
        ],
        fontWeight: "bolder",
        lineHeight: [
            "120",
            null,
            "140"
        ]
    }, props));
};

// EXTERNAL MODULE: ./src/components/articles-v2/typography/index.ts
var typography = __webpack_require__(43613);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/EmailHero.tsx









var EmailHeroComponent = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var fields = entry.fields;
    var title = (fields === null || fields === void 0 ? void 0 : fields.h1) ? (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields === null || fields === void 0 ? void 0 : fields.h1) : null;
    var subtitle = (fields === null || fields === void 0 ? void 0 : fields.h2) ? (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields === null || fields === void 0 ? void 0 : fields.h2) : null;
    var desktopHeroImage = fields === null || fields === void 0 ? void 0 : (ref = fields.desktopImage) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url;
    var mobileHeroImage = fields === null || fields === void 0 ? void 0 : (ref3 = fields.mobileImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url;
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
        justifyContent: "space-between",
        flexDir: [
            "column",
            null,
            "row"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            borderRadius: "$10x",
            width: "100%",
            minHeight: 580,
            marginVertical: "$6x",
            $largerThanSM: {
                marginVertical: "$8x",
                minHeight: 360,
                marginBottom: 0
            },
            padding: "$16x",
            marginBottom: "$6x",
            style: {
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundImage: largerThanSM ? "url(".concat(desktopHeroImage, ")") : "url(".concat(mobileHeroImage, ")")
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDir: "column",
                height: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                        flexDir: "column",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H3, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* default.h3 */.Z.h3), {
                            color: "neutrals100",
                            mb: 7,
                            children: title
                        }))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "100%",
                        $largerThanSM: {
                            width: "50%"
                        },
                        py: "$4x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_EmailInput.EmailInput, {
                            campaignName: "topicPage",
                            ctaText: "Sign up"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        marginTop: "$16x",
                        tag: "p",
                        typography: "$bodySmall",
                        color: "$contentTertiary",
                        children: subtitle
                    })
                ]
            })
        })
    });
};
var EmailHero = {
    render: EmailHeroComponent
};
/* harmony default export */ var topicPage_EmailHero = (EmailHero);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/Avatar/Avatar.mjs + 1 modules
var Avatar = __webpack_require__(72752);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(47208);
// EXTERNAL MODULE: ./src/components/shared/icons/SocialIcon.tsx
var SocialIcon = __webpack_require__(90516);
// EXTERNAL MODULE: ./src/helpers/socialLinks.ts
var socialLinks = __webpack_require__(58699);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/Experts.tsx







var getExpertsFromContext = function(context) {
    var isRelatedArticle = function(obj) {
        var ref, ref1, ref2;
        return (obj === null || obj === void 0 ? void 0 : (ref = obj.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "componentRelatedArticles";
    };
    var expertsList = context.body.content.reduce(function(acc, content) {
        if (!isRelatedArticle(content.data.target)) {
            return acc;
        }
        var loaderData = context.idToLoaderData[content.data.target.sys.id];
        var _experts;
        ((_experts = loaderData.experts) !== null && _experts !== void 0 ? _experts : []).forEach(function(expert) {
            expert && acc.push(expert);
        });
        return acc;
    }, []);
    // Deduplicate experts
    var expertsMap = {};
    expertsList.forEach(function(expert) {
        return expertsMap[expert.displayName] = expert;
    });
    return Object.values(expertsMap);
};
var SocialLink = function(param) {
    var url = param.url, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
        "aria-label": "",
        href: url,
        target: "_blank",
        analyticsName: "cosmos-topicpage-experts-sociallink",
        display: "flex",
        alignItems: "center",
        opacity: "0.2",
        _hover: {
            opacity: "1.0"
        },
        children: children
    });
};
var Bio = function(param) {
    var bio = param.bio;
    var ref = (0,react.useState)(false), isBioExpanded = ref[0], setBioExpanded = ref[1];
    var partialBio = bio === null || bio === void 0 ? void 0 : bio.split(" ").slice(0, 30).join(" ");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyMedium",
        display: "block",
        children: [
            isBioExpanded ? bio : partialBio,
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                onClick: function() {
                    return setBioExpanded(true);
                },
                analyticsName: "cosmos-topicpage-experts-bio",
                "aria-label": "",
                display: isBioExpanded || partialBio === bio ? "none" : "inline",
                children: "Read More"
            })
        ]
    });
};
var renderExpert = function(entry, _resolvedData, context) {
    var ref, ref1;
    if (!context) {
        return null;
    }
    var ref2;
    var expertsList = ((ref2 = (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.items) !== null && ref2 !== void 0 ? ref2 : []).map(function(item) {
        return item.fields;
    });
    if (expertsList.length == 0) {
        expertsList = getExpertsFromContext(context);
    }
    var ref3;
    expertsList = expertsList.slice(0, (ref3 = (ref1 = entry.fields) === null || ref1 === void 0 ? void 0 : ref1.limit) !== null && ref3 !== void 0 ? ref3 : expertsList.length);
    var _firstName, _lastName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
        flexDirection: [
            "column",
            "row"
        ],
        alignItems: "start",
        flexWrap: "wrap",
        gridColumnGap: 4,
        gridRowGap: 8,
        width: [
            "100%",
            null,
            null,
            "100%"
        ],
        mt: "8",
        children: expertsList.map(function(expert, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDirection: "column",
                width: [
                    "100%",
                    "280px"
                ],
                alignItems: [
                    "start",
                    "center"
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* Avatar */.q, {
                        size: "lg",
                        src: expert.picture,
                        initials: ((_firstName = expert.firstName) !== null && _firstName !== void 0 ? _firstName : "").charAt(0) + ((_lastName = expert.lastName) !== null && _lastName !== void 0 ? _lastName : "").charAt(0)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        marginVertical: "$4x",
                        tag: "p",
                        typography: "$subheaderXsmall",
                        children: expert.displayName
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bio, {
                        bio: expert.bio
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        width: "100%",
                        ml: "2",
                        mt: "3",
                        gridGap: "4",
                        children: [
                            expert.instagramUsername && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                                url: (0,socialLinks/* getSocialLink */.a)("instagram", expert.instagramUsername),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcon/* default */.Z, {
                                    socialPlatform: "instagram"
                                })
                            }),
                            expert.linkedInUsername && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                                url: (0,socialLinks/* getSocialLink */.a)("linkedin", expert.linkedInUsername),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcon/* default */.Z, {
                                    socialPlatform: "linkedin"
                                })
                            }),
                            expert.twitterUsername && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                                url: (0,socialLinks/* getSocialLink */.a)("twitter", expert.twitterUsername),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcon/* default */.Z, {
                                    socialPlatform: "twitter"
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
var Experts = {
    render: renderExpert
};
/* harmony default export */ var topicPage_Experts = (Experts);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs
var IconChevronRight = __webpack_require__(97322);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/shared/SellerFlowAddressInput.tsx
var SellerFlowAddressInput = __webpack_require__(58869);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/Hero.tsx













var richTextRenderer = function(richTextDocument) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#000";
    var _obj;
    var options = {
        renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_1, function(_node, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* default.h1 */.Z.h1), {
                mt: [
                    3,
                    3,
                    4
                ],
                mb: [
                    2,
                    2,
                    3
                ],
                style: {
                    color: color
                },
                children: children
            }));
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_2, function(_node, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mt: [
                    3,
                    3,
                    4
                ],
                mb: [
                    2,
                    2,
                    3
                ]
            }, typography/* default.h2 */.Z.h2), {
                style: {
                    color: color
                },
                children: children
            }));
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_3, function(_node, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mt: 3,
                mb: 2
            }, typography/* default.h3 */.Z.h3), {
                style: {
                    color: color
                },
                children: children
            }));
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_4, function(_node, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h4",
                typography: "$labelLarge",
                $largerThanMD: {
                    typography: "$subheaderSmall"
                },
                style: {
                    color: color
                },
                marginTop: "$4x",
                marginBottom: "$2x",
                $largerThanSM: {
                    marginTop: "$6x",
                    marginBottom: "$4x"
                },
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(node, children) {
            var target = "_blank";
            if (node.data.uri.startsWith("#") || node.data.uri.startsWith(globals/* COSMOS_URL */.EQ)) {
                target = "_self";
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
                href: node.data.uri,
                analyticsName: "cosmos-articles-hero-cta",
                "aria-label": "",
                target: target,
                lineHeight: "s1",
                style: {
                    color: color
                },
                fontWeight: "semibold",
                fontSize: [
                    "s1",
                    "s1",
                    "s2"
                ],
                mb: 0,
                _hover: {
                    color: "neutrals0"
                },
                _active: {
                    color: "neutrals0"
                },
                display: "flex",
                alignItems: "center",
                children: [
                    children,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronRight/* default */.Z, {
                        size: 16,
                        style: {
                            marginLeft: 12,
                            color: color,
                            position: "relative"
                        }
                    })
                ]
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(entry, children) {
            var paragraphEntry = entry;
            if (!Array.isArray(children)) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    typography: "$bodyMedium",
                    children: children
                });
            }
            var zipped = paragraphEntry.content.map(function(e, i) {
                return [
                    e,
                    children[i]
                ];
            });
            var ref = zipped.reduce(function(acc, curr) {
                var _curr = (0,_sliced_to_array/* default */.Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                if (_$entry.nodeType === dist.INLINES.EMBEDDED_ENTRY) {
                    acc.inline = acc.inline.concat(child);
                    return acc;
                }
                acc.standard = acc.standard.concat(child);
                return acc;
            }, {
                inline: [],
                standard: []
            }), inline = ref.inline, standard = ref.standard;
            // note: this re-orders the text components, i.e. if you have
            // test <inline entry> test2, it will be rendered as
            // <inline entry> test test2. This doesn't seem ideal, but works
            // for our use-case. We may want to disallow inline embedded entries
            // in the future, and just use the block type.
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    inline,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        children: standard
                    })
                ]
            });
        }), _obj)
    };
    return (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(richTextDocument, options);
};
var HeroComponent = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var fields = entry.fields;
    var color = entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.textColor;
    var title = (fields === null || fields === void 0 ? void 0 : fields.title) ? richTextRenderer(fields === null || fields === void 0 ? void 0 : fields.title, color) : null;
    var subtitle = (fields === null || fields === void 0 ? void 0 : fields.subtitle) ? richTextRenderer(fields === null || fields === void 0 ? void 0 : fields.subtitle, color) : null;
    var desktopHeroImage = entry === null || entry === void 0 ? void 0 : (ref1 = entry.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.desktopImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.file) === null || ref4 === void 0 ? void 0 : ref4.url;
    var mobileHeroImage = entry === null || entry === void 0 ? void 0 : (ref5 = entry.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.mobileImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.file) === null || ref8 === void 0 ? void 0 : ref8.url;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        as: "section",
        id: "hero-container",
        backgroundImage: [
            "url(".concat(mobileHeroImage, ")"),
            null,
            "url(".concat(desktopHeroImage, ")")
        ],
        backgroundPosition: "bottom center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100%",
        minHeight: "480px",
        my: [
            6,
            6,
            9,
            9
        ],
        px: [
            8,
            8,
            10
        ],
        py: [
            8,
            8,
            12
        ],
        gap: "6",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "100%",
        textAlign: "left",
        children: [
            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                flexDir: "column",
                width: "100%",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                width: "100%",
                children: subtitle
            }),
            (fields === null || fields === void 0 ? void 0 : fields.showOnboardingCta) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                mt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SellerFlowAddressInput/* SellerFlowAddressInput */.A, {
                    analyticsName: "cosmos-articles-topic-page-address-input",
                    channel: "DEFAULT",
                    inputLocation: "offer-cta",
                    autoFocus: false,
                    placeholderText: "Enter your address",
                    showCta: true,
                    ctaProps: {
                        actionText: "Get your free offer",
                        "aria-label": ""
                    },
                    hideLabel: true,
                    product: "SELL_DIRECT"
                })
            })
        ]
    });
};
var Hero = {
    render: HeroComponent
};
/* harmony default export */ var topicPage_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/cms/api.ts
var api = __webpack_require__(96141);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/ImageAssetLink.tsx







var renderImageLink = function(entry, resolvedData) {
    var ref;
    var imageAsset = (entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.image) || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.hydratedImageAsset);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
        href: entry.fields.uri,
        target: "_blank",
        analyticsName: "cosmos-articles-image",
        "aria-label": "",
        pr: 8,
        children: imageAsset && ImageAsset/* default.render */.Z.render(imageAsset)
    });
};
var imageAssetLinkLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var loaderReturn, ref, ref1, ref2, imageAsset, e, _obj, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loaderReturn = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,api/* fetchEntryById */.yR)("imageAsset", input === null || input === void 0 ? void 0 : (ref = input.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id, {
                            include: 2
                        })
                    ];
                case 2:
                    imageAsset = _state.sent();
                    loaderReturn.hydratedImageAsset = imageAsset;
                    return [
                        2,
                        loaderReturn
                    ];
                case 3:
                    e = _state.sent();
                    (ref3 = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref3 === void 0 ? void 0 : ref3.call(_obj, e, {
                        data: {
                            input: input
                        }
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        loaderReturn
                    ];
            }
        });
    });
    return function imageAssetLinkLoader(input) {
        return _ref.apply(this, arguments);
    };
}();
var ImageAssetLink = {
    render: renderImageLink,
    loader: imageAssetLinkLoader
};
/* harmony default export */ var topicPage_ImageAssetLink = (ImageAssetLink);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text_Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./src/cms/renderer/assets.tsx
var assets = __webpack_require__(23609);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/InfoCard.tsx





var InfoCardComponent = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: "section",
        marginVertical: "$6x",
        $largerThanXS: {
            marginVertical: "$9x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
            backgroundColor: "blue30",
            gap: "6",
            height: "100%",
            textAlign: "left",
            borderRadius: "semiRounded",
            p: [
                8,
                8,
                10,
                10
            ],
            flexDir: [
                "column",
                "column",
                "row"
            ],
            justifyContent: [
                null,
                null,
                "space-between"
            ],
            alignItems: [
                null,
                null,
                "center"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: [
                        "column",
                        "column",
                        "row"
                    ],
                    alignItems: [
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        (entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.icon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.asset) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            $largerThanXS: {
                                marginRight: "$7x"
                            },
                            marginBottom: "$5x",
                            overflow: "hidden",
                            width: ((ref6 = entry.fields.icon.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.asset) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.file) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.details) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.image) === null || ref11 === void 0 ? void 0 : ref11.width) || "100%",
                            height: ((ref12 = entry.fields.icon.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.asset) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.file) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.details) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.image) === null || ref17 === void 0 ? void 0 : ref17.height) || "100%",
                            position: "relative",
                            children: (0,assets/* default */.Z)({
                                src: (ref18 = entry.fields.icon.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.asset) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.file) === null || ref21 === void 0 ? void 0 : ref21.url,
                                contentType: ((ref22 = entry.fields.icon.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.asset) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.fields) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.file) === null || ref25 === void 0 ? void 0 : ref25.contentType) || "image/png",
                                width: ((ref26 = entry.fields.icon.fields) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.asset) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.fields) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.file) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.details) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.image) === null || ref31 === void 0 ? void 0 : ref31.width) || 100,
                                height: ((ref32 = entry.fields.icon.fields) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.asset) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.fields) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.file) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.details) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.image) === null || ref37 === void 0 ? void 0 : ref37.height) || 100
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            flexDir: "column",
                            children: [
                                (entry === null || entry === void 0 ? void 0 : (ref38 = entry.fields) === null || ref38 === void 0 ? void 0 : ref38.title) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                                    lineHeight: "s2",
                                    fontSize: "s2",
                                    fontWeight: "semibold",
                                    fontFamily: "sans",
                                    mb: "4",
                                    children: entry === null || entry === void 0 ? void 0 : (ref39 = entry.fields) === null || ref39 === void 0 ? void 0 : ref39.title
                                }),
                                (entry === null || entry === void 0 ? void 0 : (ref40 = entry.fields) === null || ref40 === void 0 ? void 0 : ref40.subtitle) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                                    lineHeight: [
                                        "s0",
                                        "s1"
                                    ],
                                    fontSize: [
                                        "s0",
                                        "s1"
                                    ],
                                    children: entry === null || entry === void 0 ? void 0 : (ref41 = entry.fields) === null || ref41 === void 0 ? void 0 : ref41.subtitle
                                })
                            ]
                        })
                    ]
                }),
                (entry === null || entry === void 0 ? void 0 : (ref42 = entry.fields) === null || ref42 === void 0 ? void 0 : ref42.ctaLink) && (entry === null || entry === void 0 ? void 0 : (ref43 = entry.fields) === null || ref43 === void 0 ? void 0 : ref43.ctaText) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
                    "aria-label": "Info card link",
                    href: entry === null || entry === void 0 ? void 0 : (ref44 = entry.fields) === null || ref44 === void 0 ? void 0 : ref44.ctaLink,
                    analyticsName: "cosmos-topic-page-info-card",
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                            lineHeight: [
                                "s0",
                                "s0",
                                "s1"
                            ],
                            fontWeight: "semibold",
                            color: "brand50",
                            fontSize: "s1",
                            children: entry.fields.ctaText
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronRight/* default */.Z, {
                            size: 16,
                            style: {
                                marginLeft: 8,
                                color: "#0D76D6",
                                position: "relative"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var InfoCard = {
    render: InfoCardComponent
};
/* harmony default export */ var topicPage_InfoCard = (InfoCard);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Image/Image.mjs
var Image = __webpack_require__(61442);
// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var renderer = __webpack_require__(32239);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/MediaAssetSection.tsx









var renderMediaAssetSection = function(entry, resolvedData, context) {
    var ref;
    /*
   * Prefer resolvedData over entry because mediaAssetSectionLoader below fetches
   * the nested fields for each componentMediaAsset.
   */ var mediaAssets = (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.mediaAssets) || (entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.mediaAssets);
    if ((mediaAssets === null || mediaAssets === void 0 ? void 0 : mediaAssets.length) === 0) {
        return null;
    }
    var idToDataLoader = context === null || context === void 0 ? void 0 : context.idToLoaderData;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
        paddingVertical: "$4x",
        $largerThanSM: {
            paddingVertical: "$8x"
        },
        children: mediaAssets === null || mediaAssets === void 0 ? void 0 : mediaAssets.map(function(item, index) {
            var ref, ref1, ref2, ref3;
            var _fields = item.fields, title = _fields.title, subtitle = _fields.subtitle, logo = _fields.logo, content = _fields.content;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                width: "100%",
                $largerThanXS: {
                    width: "50%"
                },
                $largerThanSM: {
                    width: "33%"
                },
                justifyContent: "space-between",
                rowGap: "$10x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        children: [
                            (logo === null || logo === void 0 ? void 0 : (ref = logo.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                width: 50,
                                height: 50,
                                paddingBottom: "$2x",
                                $largerThanSM: {
                                    paddingBottom: "$4x"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                    position: "absolute",
                                    src: logo.fields.asset.fields.file.url,
                                    alt: logo === null || logo === void 0 ? void 0 : logo.fields.asset.fields.description,
                                    objectFit: "cover"
                                })
                            }),
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                                fontWeight: "semibold",
                                fontSize: "s2",
                                mb: 3,
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                                color: "neutrals90",
                                children: subtitle
                            })
                        ]
                    }),
                    content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        paddingTop: "$4x",
                        flexDirection: "row",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                            body: content,
                            idToLoaderData: idToDataLoader,
                            entryLookup: topicPageV2
                        })
                    })
                ]
            }, "media-asset-".concat(Math.random(), "-").concat(index));
        })
    });
};
var mediaAssetSectionLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var ref, ref1, loaderReturn, entryIds, result, e, _obj, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loaderReturn = {
                        mediaAssets: []
                    };
                    entryIds = input === null || input === void 0 ? void 0 : (ref = input.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mediaAssets) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                    });
                    if ((entryIds === null || entryIds === void 0 ? void 0 : entryIds.length) === 0 || entryIds === undefined) {
                        return [
                            2,
                            loaderReturn
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,api/* fetchEntriesById */.x5)("componentMediaAsset", entryIds, {
                            include: 2
                        })
                    ];
                case 2:
                    result = _state.sent();
                    loaderReturn.mediaAssets = result === null || result === void 0 ? void 0 : result.map(function(entry) {
                        return entry !== null && entry !== void 0 ? entry : null;
                    });
                    return [
                        2,
                        loaderReturn
                    ];
                case 3:
                    e = _state.sent();
                    (ref2 = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref2 === void 0 ? void 0 : ref2.call(_obj, e, {
                        data: {
                            input: input
                        }
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        loaderReturn
                    ];
            }
        });
    });
    return function mediaAssetSectionLoader(input) {
        return _ref.apply(this, arguments);
    };
}();
var MediaAssetSection = {
    render: renderMediaAssetSection,
    loader: mediaAssetSectionLoader
};
/* harmony default export */ var topicPage_MediaAssetSection = (MediaAssetSection);

;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/NavBar.tsx






var renderNavBar = function(_entry, resolvedData) {
    if (!(resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.navBarItems) || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.navBarItems.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        my: "$7x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            flexWrap: "wrap",
            gap: [
                5,
                5,
                6
            ],
            backgroundColor: [
                "unset",
                "unset",
                "neutrals20"
            ],
            borderRadius: "roundedSquare",
            px: 5,
            py: 4,
            justifyContent: [
                "center",
                "center",
                "flex-start"
            ],
            alignItems: "center",
            children: resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.navBarItems.map(function(param, index) {
                var displayText = param.displayText, slug = param.slug;
                if (!displayText) {
                    return null;
                }
                if ((resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.currentSlug) === slug) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                        fontWeight: [
                            "semibold",
                            "semibold",
                            "unset"
                        ],
                        color: "neutrals0",
                        backgroundColor: "brand50",
                        boxShadow: [
                            "z1",
                            "z1",
                            "unset"
                        ],
                        py: [
                            4,
                            4,
                            2
                        ],
                        px: [
                            6,
                            6,
                            5
                        ],
                        borderRadius: [
                            "roundedSmooth",
                            "roundedSmooth",
                            "roundedSquare"
                        ],
                        children: displayText
                    });
                }
                return displayText && slug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                    boxShadow: [
                        "z1",
                        "z1",
                        "unset"
                    ],
                    py: [
                        4,
                        4,
                        0
                    ],
                    px: [
                        6,
                        6,
                        0
                    ],
                    borderRadius: "roundedSmooth",
                    analyticsName: "cosmos-topic-page-nav-item-link",
                    "aria-label": "Go to ".concat(displayText, " page"),
                    href: slug,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                        color: "neutrals90",
                        children: displayText
                    })
                }, "nav-bar-item-".concat(index, "-").concat(slug));
            })
        })
    });
};
var navBarLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var ref, ref1, ref2, ref3, ref4, ref5, currentSlug, ref6, topicPageSysIds, response, topicPageResponseSysIds, navBarItems;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentSlug = root === null || root === void 0 ? void 0 : (ref = root.fields) === null || ref === void 0 ? void 0 : ref.slug;
                    if (((ref6 = (ref1 = input.fields) === null || ref1 === void 0 ? void 0 : ref1.items) !== null && ref6 !== void 0 ? ref6 : []).length === 0) {
                        return [
                            2,
                            {
                                navBarItems: [],
                                currentSlug: currentSlug
                            }
                        ];
                    }
                    topicPageSysIds = [];
                    input === null || input === void 0 ? void 0 : (ref2 = input.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(item) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        if ((item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.topicPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.type) === "Link" && (item === null || item === void 0 ? void 0 : (ref3 = item.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.topicPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sys) === null || ref5 === void 0 ? void 0 : ref5.id)) {
                            var ref6, ref7, ref8;
                            topicPageSysIds.push(item === null || item === void 0 ? void 0 : (ref6 = item.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.topicPage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sys) === null || ref8 === void 0 ? void 0 : ref8.id);
                        }
                    });
                    return [
                        4,
                        (0,api/* fetchEntriesById */.x5)("topicPage", topicPageSysIds, {
                            select: "sys.id,fields.slug,fields.topicName"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    topicPageResponseSysIds = response === null || response === void 0 ? void 0 : response.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                    });
                    navBarItems = input === null || input === void 0 ? void 0 : (ref4 = input.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.items) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                        var slug = (item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : ref.url) || (item === null || item === void 0 ? void 0 : (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.topicPage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.slug);
                        if ((item === null || item === void 0 ? void 0 : (ref4 = item.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.topicPage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sys) === null || ref6 === void 0 ? void 0 : ref6.id) && (topicPageResponseSysIds === null || topicPageResponseSysIds === void 0 ? void 0 : topicPageResponseSysIds.includes(item === null || item === void 0 ? void 0 : (ref7 = item.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.topicPage) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sys) === null || ref9 === void 0 ? void 0 : ref9.id))) {
                            var ref11, ref12;
                            slug = (ref11 = response === null || response === void 0 ? void 0 : response.find(function(r) {
                                var ref, ref1, ref2, ref3;
                                return (r === null || r === void 0 ? void 0 : (ref = r.sys) === null || ref === void 0 ? void 0 : ref.id) === (item === null || item === void 0 ? void 0 : (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.topicPage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id);
                            })) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : ref12.slug;
                        }
                        return {
                            displayText: item === null || item === void 0 ? void 0 : (ref10 = item.fields) === null || ref10 === void 0 ? void 0 : ref10.displayText,
                            slug: slug
                        };
                    });
                    return [
                        2,
                        {
                            navBarItems: navBarItems,
                            currentSlug: currentSlug
                        }
                    ];
            }
        });
    });
    return function navBarLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var NavBar = {
    render: renderNavBar,
    loader: navBarLoader
};
/* harmony default export */ var topicPage_NavBar = (NavBar);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/shadows.mjs
var shadows = __webpack_require__(50313);
// EXTERNAL MODULE: ./src/components/shared/CardCarousel.tsx
var CardCarousel = __webpack_require__(53247);
;// CONCATENATED MODULE: ./src/components/articles-v2/topicPage/TopTopics.tsx














var TopTopicsCard = function(param) {
    var topicName = param.topicName, slug = param.slug, topicThumbnail = param.topicThumbnail, cardIndex = param.cardIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var photoUrl = topicThumbnail === null || topicThumbnail === void 0 ? void 0 : (ref = topicThumbnail.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url;
    var ref12, ref13;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
        width: "100%",
        cursor: "pointer",
        flexDirection: "column",
        p: 0,
        css: {
            boxShadow: shadows/* default.small */.Z.small
        },
        role: "group",
        borderRadius: "semiRounded",
        overflow: "hidden",
        height: "95%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
            "aria-label": "Go to top topic page",
            href: "".concat(globals/* COSMOS_URL */.EQ).concat(slug),
            analyticsName: "cosmos-article-top-topics-card",
            onClick: function(e) {
                e.stopPropagation();
            },
            display: "flex",
            alignItems: "flex-end",
            p: [
                5,
                5,
                7
            ],
            height: "100%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                    zIndex: "0",
                    as: "h1",
                    lineHeight: "120",
                    color: "neutrals0",
                    fontSize: [
                        "s2",
                        null,
                        "s3",
                        "s3"
                    ],
                    fontWeight: "semibold",
                    children: topicName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    position: "absolute",
                    zIndex: -1,
                    top: 0,
                    left: 0,
                    width: "100%",
                    children: [
                        photoUrl ? (0,assets/* default */.Z)({
                            src: photoUrl,
                            contentType: (topicThumbnail === null || topicThumbnail === void 0 ? void 0 : (ref2 = topicThumbnail.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.contentType) || "image/png",
                            width: (ref12 = topicThumbnail === null || topicThumbnail === void 0 ? void 0 : (ref4 = topicThumbnail.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.width) !== null && ref12 !== void 0 ? ref12 : 100,
                            height: (ref13 = topicThumbnail === null || topicThumbnail === void 0 ? void 0 : (ref8 = topicThumbnail.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.file) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.details) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.image) === null || ref11 === void 0 ? void 0 : ref11.height) !== null && ref13 !== void 0 ? ref13 : 100
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                            alt: "Entrance to home",
                            src: cardIndex && cardIndex % 2 === 0 ? "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1680888195610-48794.png?preset=square-2048" : "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1680888329782-61343.png?preset=square-2048",
                            objectPosition: "left"
                        }),
                        " "
                    ]
                })
            ]
        })
    });
};
var renderTopTopics = function(entry, resolvedData) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    // Replace self-reference item to root
    if (entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.items) {
        var selfIndex = entry.fields.items.findIndex(function(item) {
            return !item.fields;
        });
        if (selfIndex !== -1 && (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.topicName) && (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.slug)) {
            entry.fields.items[selfIndex].fields = {
                topicName: resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.topicName,
                slug: resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.slug
            };
        }
    }
    var ref9, ref10;
    var topics = (ref10 = (ref9 = (ref3 = entry === null || entry === void 0 ? void 0 : (ref1 = entry.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
        var ref;
        return !!(item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : ref.slug);
    })) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
        return {
            topicName: item.fields.topicName,
            slug: item.fields.slug,
            topicThumbnail: item.fields.topicThumbnail
        };
    })) !== null && ref9 !== void 0 ? ref9 : resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.topics) !== null && ref10 !== void 0 ? ref10 : [];
    var ref11;
    topics = topics.slice(0, (ref11 = (ref4 = entry.fields) === null || ref4 === void 0 ? void 0 : ref4.limit) !== null && ref11 !== void 0 ? ref11 : topics.length);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        my: "$6x",
        $largerThanXS: {
            my: "$10x"
        },
        children: [
            (entry === null || entry === void 0 ? void 0 : (ref5 = entry.fields) === null || ref5 === void 0 ? void 0 : ref5.title) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* default.h3 */.Z.h3), {
                mb: 4,
                children: entry === null || entry === void 0 ? void 0 : (ref6 = entry.fields) === null || ref6 === void 0 ? void 0 : ref6.title
            })),
            (entry === null || entry === void 0 ? void 0 : (ref7 = entry.fields) === null || ref7 === void 0 ? void 0 : ref7.subtitle) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                mb: 4,
                children: entry === null || entry === void 0 ? void 0 : (ref8 = entry.fields) === null || ref8 === void 0 ? void 0 : ref8.subtitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarousel/* default */.Z, {
                height: [
                    "320px",
                    "320px",
                    "380px"
                ],
                showIndicators: true,
                children: topics.map(function(param, index) {
                    var topicName = param.topicName, slug = param.slug, topicThumbnail = param.topicThumbnail;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarousel/* CarouselItem */.d, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopTopicsCard, {
                                topicName: topicName || "",
                                slug: slug,
                                cardIndex: index,
                                topicThumbnail: topicThumbnail
                            })
                        }, index)
                    }, "carousel-item-".concat(index, "-").concat(slug));
                })
            })
        ]
    });
};
var topTopicsLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var ref, ref1, ref2, _topicName, _slug, client, response, _topicName1, _slug1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (((ref2 = (ref = input.fields) === null || ref === void 0 ? void 0 : ref.items) !== null && ref2 !== void 0 ? ref2 : []).length > 0) {
                        ;
                        return [
                            2,
                            {
                                topics: [],
                                topicName: (_topicName = root === null || root === void 0 ? void 0 : root.fields.topicName) !== null && _topicName !== void 0 ? _topicName : null,
                                slug: (_slug = root === null || root === void 0 ? void 0 : root.fields.slug) !== null && _slug !== void 0 ? _slug : null
                            }
                        ];
                    }
                    client = (0,api/* createContentfulClient */.u_)();
                    return [
                        4,
                        client.getEntries({
                            content_type: "topicPage",
                            order: "sys.createdAt",
                            "fields.slug[match]": "/articles/topic/",
                            select: "fields.slug,fields.topicName",
                            limit: (ref1 = input.fields) === null || ref1 === void 0 ? void 0 : ref1.limit
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            topics: response.items.map(function(item) {
                                return item.fields;
                            }),
                            topicName: (_topicName1 = root === null || root === void 0 ? void 0 : root.fields.topicName) !== null && _topicName1 !== void 0 ? _topicName1 : null,
                            slug: (_slug1 = root === null || root === void 0 ? void 0 : root.fields.slug) !== null && _slug1 !== void 0 ? _slug1 : null
                        }
                    ];
            }
        });
    });
    return function topTopicsLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var TopTopics = {
    render: renderTopTopics,
    loader: topTopicsLoader
};
/* harmony default export */ var topicPage_TopTopics = (TopTopics);

// EXTERNAL MODULE: ./src/components/shared/Articles.tsx
var Articles = __webpack_require__(68153);
;// CONCATENATED MODULE: ./src/cms/entries/topicPageV2.ts











var topicPageEntryLookup = {
    block: {
        componentRelatedArticles: Articles/* default */.ZP,
        ctaEmailCapture: EmailInput/* default */.Z,
        componentTopTopics: topicPage_TopTopics,
        componentExperts: topicPage_Experts,
        componentEmailHero: topicPage_EmailHero,
        componentHeroV2: topicPage_Hero,
        componentMediaAssetSection: topicPage_MediaAssetSection,
        componentImageAssetLink: topicPage_ImageAssetLink,
        componentInfoCard: topicPage_InfoCard,
        componentNavBar: topicPage_NavBar,
        imageAsset: ImageAsset/* default */.Z
    },
    inline: {}
};
/* harmony default export */ var topicPageV2 = (topicPageEntryLookup);


/***/ }),

/***/ 53247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ CarouselItem; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61151);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81762);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48135);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97322);






// At different breakpoints, we show a different number of cards per slide
var responsiveCarousel = {
    XS: 1,
    SM: 1,
    MD: 2,
    LG: 3,
    XL: 3
};
var CarouselItem = function(param) {
    var children = param.children, numCardsVisible = param.numCardsVisible;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: [
            4,
            6
        ],
        minWidth: [
            "".concat(100 / (numCardsVisible !== null && numCardsVisible !== void 0 ? numCardsVisible : responsiveCarousel.XS), "%"),
            "".concat(100 / (numCardsVisible !== null && numCardsVisible !== void 0 ? numCardsVisible : responsiveCarousel.SM), "%"),
            "".concat(100 / (numCardsVisible !== null && numCardsVisible !== void 0 ? numCardsVisible : responsiveCarousel.MD), "%"),
            "".concat(100 / (numCardsVisible !== null && numCardsVisible !== void 0 ? numCardsVisible : responsiveCarousel.LG), "%"),
            "".concat(100 / (numCardsVisible !== null && numCardsVisible !== void 0 ? numCardsVisible : responsiveCarousel.XL), "%"), 
        ],
        children: children
    });
};
// Determines length of carousel depending on screen size
function useCarouselLength(totalItems, numCardsVisible) {
    var ref = (0,_opendoor_bricks_hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .F)(), isSmallMobile = ref.isSmallMobile, isMobile = ref.isMobile, isTablet = ref.isTablet, isDesktop = ref.isDesktop, isLargeDesktop = ref.isLargeDesktop;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(totalItems), carouselLength = ref1[0], setCarouselLength = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1), numInView = ref2[0], setNumInView = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var base = 1;
        if (isSmallMobile) {
            base = responsiveCarousel.XS;
        } else if (isMobile) {
            base = responsiveCarousel.SM;
        } else if (isTablet) {
            base = responsiveCarousel.MD;
        } else if (isDesktop) {
            base = responsiveCarousel.LG;
        } else if (isLargeDesktop) {
            base = responsiveCarousel.XL;
        }
        if (numCardsVisible) {
            base = numCardsVisible;
        }
        setCarouselLength(Math.round(totalItems / base));
        setNumInView(base);
    }, [
        isSmallMobile,
        isMobile,
        isTablet,
        isDesktop,
        isLargeDesktop
    ]);
    return {
        numInView: numInView,
        carouselLength: carouselLength
    };
}
function useCarousel(// Total number of items in carousel
totalItems, // Miliseconds bewteen auto rotation
duration, numCardsVisible) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), paused = ref1[0], setPaused = ref1[1];
    var ref2 = useCarouselLength(totalItems, numCardsVisible), carouselLength = ref2.carouselLength, numInView = ref2.numInView;
    var updateIndex = function(newIndex) {
        if (newIndex < 0) {
            newIndex = carouselLength - 1;
        } else if (newIndex >= carouselLength) {
            newIndex = 0;
        }
        setActiveIndex(newIndex);
    };
    var goToPrevious = function() {
        updateIndex(activeIndex - 1);
    };
    var goToNext = function() {
        updateIndex(activeIndex + 1);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // If duration is passed in, create a timer to set up auto-rotation behavior
        if (duration) {
            var interval = setInterval(function() {
                if (!paused) {
                    updateIndex(activeIndex + 1);
                }
            }, duration);
            return function() {
                if (interval) {
                    clearInterval(interval);
                }
            };
        }
        return;
    });
    // Returns carousel state and handler functions
    return {
        activeIndex: activeIndex,
        updateIndex: updateIndex,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        setPaused: setPaused,
        carouselLength: carouselLength,
        numInView: numInView
    };
}
var CardCarousel = function(param) {
    var children = param.children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "400px" : _height, _autoRotate = param.autoRotate, autoRotate = _autoRotate === void 0 ? false : _autoRotate, _showIndicators = param.showIndicators, showIndicators = _showIndicators === void 0 ? false : _showIndicators, numCardsVisible = param.numCardsVisible;
    var totalItems = react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children);
    var ref = useCarousel(totalItems, autoRotate ? 3000 : undefined, numCardsVisible), activeIndex = ref.activeIndex, updateIndex = ref.updateIndex, goToNext = ref.goToNext, goToPrevious = ref.goToPrevious, setPaused = ref.setPaused, numInView = ref.numInView, carouselLength = ref.carouselLength;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                onMouseEnter: function() {
                    return setPaused(true);
                },
                onMouseLeave: function() {
                    return setPaused(false);
                },
                position: "relative",
                overflow: "hidden",
                height: height,
                width: width,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        height: height,
                        width: "100%",
                        position: "absolute",
                        transition: "transform 0.3s",
                        style: {
                            transform: "translateX(-".concat(activeIndex * 100, "%)")
                        },
                        children: react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function(child) {
                            return child;
                        })
                    }),
                    totalItems > numInView && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                variant: "icon",
                                position: "absolute",
                                left: "0",
                                top: "50%",
                                transform: "transformY(-50%)",
                                analyticsName: "cosmos-card-carousel-previous",
                                "aria-label": "Go to previous carousel item",
                                onClick: goToPrevious,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: 24,
                                    color: "#6E6E6E"
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                variant: "icon",
                                position: "absolute",
                                top: "50%",
                                transform: "transformY(-50%)",
                                right: "0",
                                analyticsName: "cosmos-card-carousel-next",
                                "aria-label": "Go to next carousel item",
                                onClick: goToNext,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    size: 24,
                                    color: "#6E6E6E"
                                })
                            })
                        ]
                    })
                ]
            }),
            showIndicators && carouselLength > 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                gap: "4",
                px: [
                    6,
                    8
                ],
                py: [
                    6,
                    8
                ],
                flexWrap: "wrap",
                justifyContent: "center",
                children: Array(carouselLength).fill(0).map(function(_child, index) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        variant: "ghost",
                        analyticsName: "cosmos-card-carousel-indicator",
                        "aria-label": "Go to numbered carousel item",
                        onClick: function() {
                            updateIndex(index);
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "8px",
                            width: "8px",
                            borderRadius: "rounded",
                            backgroundColor: index === activeIndex ? "brand50" : "neutrals40",
                            _hover: {
                                backgroundColor: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].brand30 */ .ZP.brand30
                            }
                        })
                    }, "card-carousel-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCarousel);


/***/ }),

/***/ 51416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EmailInput": function() { return /* binding */ EmailInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2775);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4796);
/* harmony import */ var _opendoor_bricks_core_Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59007);
/* harmony import */ var _opendoor_bricks_hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61151);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77997);








var EmailInput = function(props) {
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_1__/* .useObservability */ .C3)().trackEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmitError = ref1[0], setIsSubmitError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmitted = ref2[0], setIsSubmitted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmitting = ref3[0], setIsSubmitting = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isValidEmail = ref4[0], setIsValidEmail = ref4[1];
    var isMobile = (0,_opendoor_bricks_hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)().isMobile;
    var isFromTopicPage = props.campaignName === "topicPage";
    var onEmailChange = function(_event, newValue, validFormat) {
        setEmail(newValue || "");
        setIsSubmitError(false);
        setIsSubmitted(false);
        setIsValidEmail(validFormat || false);
    };
    var onEmailSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // TODO: remove categoryOverride
                        // observability is initialized with 'cosmos' as the category for all events
                        trackEvent("cta-click", "subscribe-to-mailing-list", undefined, {
                            categoryOverride: "homepage"
                        });
                        if (!isValidEmail) {
                            setIsSubmitError(true);
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        setIsSubmitError(false);
                        return [
                            4,
                            fetch("/api/v1/marketing/inbound-campaign-email-capture", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    campaign_name: props.campaignName,
                                    email: email
                                })
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.ok) {
                            setIsSubmitError(false);
                            setIsSubmitting(false);
                            setIsSubmitted(true);
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(false);
                        setIsSubmitError(true);
                        setIsSubmitted(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onEmailSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            !isFromTopicPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                display: "inline-block",
                mb: "4",
                color: "neutrals0",
                htmlFor: "call-to-action-email",
                children: "Enter your email address"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                flexDir: "column",
                backgroundColor: [
                    null,
                    null,
                    "neutrals0"
                ],
                borderRadius: "roundedSquare",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        alignItems: "center",
                        flexDir: [
                            "column",
                            null,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_core_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                analyticsName: "cosmos-email-input-submit-email-to-receive-tips",
                                mt: 3,
                                padding: 4,
                                id: "call-to-action-email",
                                type: "email",
                                "aria-label": "email",
                                value: email,
                                border: "none",
                                borderRadius: "roundedSquare",
                                unboundedWidth: true,
                                disabled: isSubmitting,
                                name: "call-to-action-email",
                                onChange: onEmailChange,
                                autoComplete: "email",
                                _focus: {
                                    outline: "none"
                                }
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                width: [
                                    "100%",
                                    null,
                                    "inherit"
                                ],
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                    backgroundColor: [
                                        "neutrals100",
                                        null,
                                        "brand50"
                                    ],
                                    fontSize: "s0",
                                    width: [
                                        "100%",
                                        null,
                                        "175px"
                                    ],
                                    mt: [
                                        3,
                                        null,
                                        0
                                    ],
                                    mx: [
                                        0,
                                        null,
                                        3
                                    ],
                                    onClick: onEmailSubmit,
                                    disabled: isSubmitted,
                                    success: isSubmitted && !isSubmitError ? true : undefined,
                                    loading: isSubmitting,
                                    loadingText: "Subscribing...",
                                    size: isMobile ? "md" : "sm",
                                    "aria-label": isSubmitted ? "" : "Submit email to recieve tips",
                                    analyticsName: "cosmos-email-input-submit-email-to-receive-tips",
                                    children: isSubmitted ? "Submitted" : props.ctaText || "Get tips and trends"
                                })
                            })
                        ]
                    }),
                    isSubmitError && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        fontSize: "s0",
                        lineHeight: "s00",
                        ml: 4,
                        mb: 3,
                        mt: [
                            4,
                            null,
                            0
                        ],
                        color: [
                            "neutrals0",
                            null,
                            "red50"
                        ],
                        children: "Sorry, that didn’t go through, please check your email address and submit again."
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);